// extracted by mini-css-extract-plugin
module.exports = {"errorCard":"ErrorPage_errorCard__1P9PE","errorHeader":"ErrorPage_errorHeader__2mb5l","title":"ErrorPage_title__3q9ZM"};